<button nz-button nzType="primary" nzShape="circle" (click)="openUserGuide()">
  <i nz-icon nzType="question" nzTheme="outline"></i>
</button>

<nz-drawer
  [nzVisible]="open"
  [nzClosable]="true"
  [nzMaskClosable]="false"
  [nzWidth]="'100%'"
  [nzBodyStyle]="{ height: 'calc(100% - 55px)', overflow: 'auto', 'padding-bottom': '53px' }"
  nzPlacement="right"
  nzTitle="User Guide"
  (nzOnClose)="closeUserGuide()"
>
  <div *nzDrawerContent>
    <nz-row [nzGutter]="[15, 5]">
      <nz-col nzSpan="6">
        <ul nz-menu nzMode="inline">
          <li nz-submenu nzTitle="Common" nzIcon="info-circle" nzOpen>
            <ul>
              <li nz-menu-group nzTitle="Header">
                <ul>
                  <li nz-menu-item nzSelected (click)="loadTerm()">Vendor Selector</li>
                  <li nz-menu-item>User Data</li>
                  <li nz-menu-item>User Messages</li>
                </ul>
              </li>

              <li nz-menu-group nzTitle="Dashboard">
                <ul>
                  <li nz-menu-item>Terms of use</li>
                  <li nz-menu-item>Widgets</li>
                  <li nz-menu-item>User Settings</li>
                </ul>
              </li>
            </ul>
          </li>

          <li nz-submenu nzTitle="Vendor Items" nzIcon="appstore">
            <ul>
              <li nz-menu-item>Shows</li>
              <li nz-menu-item>Attractions</li>
              <li nz-menu-item>Dining</li>
              <li nz-menu-item>Hotels</li>
            </ul>
          </li>

          <li nz-menu-item>Schedules</li>
          <li nz-menu-item>Rates</li>
          <li nz-menu-item>Allotments</li>
          <li nz-menu-item>Vacation Packages</li>
          <li nz-menu-item>Marketing Contracts</li>

          <li nz-submenu nzTitle="Manage Inventory" nzIcon="setting">
            <ul>
              <li nz-menu-item>Manage Amenities</li>
              <li nz-menu-item>Manage Categories</li>
              <li nz-menu-item>Manage Ticket Names</li>
            </ul>
          </li>
        </ul>
      </nz-col>

      <nz-col nzSpan="18">
        @if (loaded) {
          <div class="content-loaded" [innerHTML]="content"></div>
        }
      </nz-col>
      <!--      <nz-col nzSpan="18">-->

      <!--        &lt;!&ndash;@Common&ndash;&gt;-->
      <!--          &lt;!&ndash;@Header&ndash;&gt;-->
      <!--        <div id="vendorSelector">-->
      <!--          <h2>Vendor Selector</h2>-->
      <!--        </div>-->

      <!--        <div id="userData">-->
      <!--          <h2>User Data</h2>-->
      <!--        </div>-->

      <!--        <div id="userMessages">-->
      <!--          <h2>User Messages</h2>-->
      <!--        </div>-->

      <!--        &lt;!&ndash;@Dashboard&ndash;&gt;-->
      <!--        <div id="termsOfUse">-->
      <!--          <h2>Terms Of Use</h2>-->
      <!--        </div>-->

      <!--        <div id="widgets">-->
      <!--          <h2>Widgets</h2>-->
      <!--        </div>-->

      <!--        <div id="userSettings">-->
      <!--          <h2>User Settings</h2>-->
      <!--        </div>-->

      <!--        &lt;!&ndash;@VendorItems&ndash;&gt;-->
      <!--        <div id="viShows">-->
      <!--          <h2>Shows</h2>-->
      <!--        </div>-->

      <!--        <div id="viAttractions">-->
      <!--          <h2>Attractions</h2>-->
      <!--        </div>-->

      <!--        <div id="viDining">-->
      <!--          <h2>Dining</h2>-->
      <!--        </div>-->

      <!--        <div id="viHotels">-->
      <!--          <h2>Hotels</h2>-->
      <!--        </div>-->

      <!--        &lt;!&ndash;@Other Menu Items&ndash;&gt;-->
      <!--        <div id="schedules">-->
      <!--          <h2>Schedules</h2>-->
      <!--        </div>-->

      <!--        <div id="rates">-->
      <!--          <h2>Rates</h2>-->
      <!--        </div>-->

      <!--        <div id="allotments">-->
      <!--          <h2>Allotments</h2>-->
      <!--        </div>-->

      <!--        <div id="vacationPackages">-->
      <!--          <h2>Vacation Packages</h2>-->
      <!--        </div>-->

      <!--        <div id="marketingContracts">-->
      <!--          <h2>Marketing Contracts</h2>-->
      <!--        </div>-->

      <!--        &lt;!&ndash;@ManageInventory&ndash;&gt;-->
      <!--        <div id="manageAmenities">-->
      <!--          <h2>Manage Amenities</h2>-->
      <!--        </div>-->

      <!--        <div id="manageCategories">-->
      <!--          <h2>Manage Categories</h2>-->
      <!--        </div>-->

      <!--        <div id="manageTicketNames">-->
      <!--          <h2>Manage Ticket Names</h2>-->
      <!--        </div>-->

      <!--      </nz-col>-->
    </nz-row>
  </div>
</nz-drawer>
